import { useState } from 'react';

import { Loader } from '@/components/Loader';
import type { Maybe } from '@/lib/types';
import WaterResistanceModal from '@/views/ProductDetailView/components/TechnicalData/components/WaterResistanceModal/WaterResistanceModal';

import { Feature, type FeatureProps } from './Feature/Feature';

import * as S from './Features.styles';

interface FeaturesProps {
  keyFeatures: Maybe<FeatureProps[]>;
  loading: boolean;
  waterResistanceTextComputed?: string;
}

export const Features = ({
  keyFeatures,
  loading,
  waterResistanceTextComputed,
}: FeaturesProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [waterResistanceData, setWaterResistanceData] = useState('');

  const handleModalOpen = (data: string) => {
    setOpenModal(true);
    setWaterResistanceData(data);
  };

  return (
    <>
      {loading ? (
        <Loader data-test-id='FeaturesLoader' height={150} />
      ) : (
        <S.KeyFeatures>
          {keyFeatures?.map(({ displayName, icon, name, value }, index) => (
            <Feature
              key={name}
              data-test-id={`FeaturesFeature-${index}`}
              displayName={displayName}
              handleModalOpen={handleModalOpen}
              icon={icon}
              name={name}
              value={value}
            />
          ))}
          <WaterResistanceModal
            data-test-id='FeaturesWaterResistanceModal'
            onClose={() => {
              setOpenModal(false);
            }}
            openModal={openModal}
            waterResistanceData={waterResistanceData}
            waterResistanceTextComputed={waterResistanceTextComputed ?? ''}
          />
        </S.KeyFeatures>
      )}
    </>
  );
};
